import { Component, OnInit } from '@angular/core';
import {MatDialogRef} from '@angular/material/dialog';


@Component({
  selector: 'app-popup-termo-adiantamento',
  templateUrl: './popup-termo-adiantamento.component.html',
  styleUrls: ['./popup-termo-adiantamento.component.css']
})
export class PopupTermoAdiantamentoComponent implements OnInit {

  constructor(private dialogRef: MatDialogRef<PopupTermoAdiantamentoComponent>) { }

  ngOnInit() {
  }

  closePopup(){
    this.dialogRef.close(false);
  }

  agreePopup(){
    this.dialogRef.close(true);
  }

}
